/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The type of request being made to the account manager
 * @export
 */
export const SendRequestToAccountManagerRequestType = {
    JobSlotLimitIncrease: 'JobSlotLimitIncrease',
    SubscriptionChange: 'SubscriptionChange',
    UpgradeToSubscription: 'UpgradeToSubscription',
    CompanyPromotionVideo: 'CompanyPromotionVideo'
};
export function instanceOfSendRequestToAccountManagerRequestType(value) {
    for (const key in SendRequestToAccountManagerRequestType) {
        if (Object.prototype.hasOwnProperty.call(SendRequestToAccountManagerRequestType, key)) {
            if (SendRequestToAccountManagerRequestType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function SendRequestToAccountManagerRequestTypeFromJSON(json) {
    return SendRequestToAccountManagerRequestTypeFromJSONTyped(json, false);
}
export function SendRequestToAccountManagerRequestTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function SendRequestToAccountManagerRequestTypeToJSON(value) {
    return value;
}
export function SendRequestToAccountManagerRequestTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
